import React from 'react';
import { PropTypes } from 'prop-types';
import ReactLinkify from 'react-linkify';
import { capitalizeFirstLetter } from '../../../../../../utils/api/index';

const TrWithLabelAndValue = ({ item, values, styles }) => {
  const label = capitalizeFirstLetter(item.label);

  return (
    <tr>
      <th className={styles.thClassName.className}>{`${label}:` } </th>
      <td className="mb-0 text-left break-words whitespace-normal">
        <ReactLinkify>
          {values[item.key] || 'No Info'}
        </ReactLinkify>
      </td>
    </tr>
  );
};

TrWithLabelAndValue.propTypes = {
  item: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
};

export default TrWithLabelAndValue;
